export const TIME_SCHEDULE = {
  MORNING: "morning",
  AFTERNOON: "afternoon",
  EVENING: "evening",
};
